import { render } from "./onboarding-reporting.vue?vue&type=template&id=95e14180&lang=pug"
import script from "./onboarding-reporting.vue?vue&type=script&lang=js"
export * from "./onboarding-reporting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__